const requireRoutes = require.context(".", false, /\.route\.js$/);
let routes = [];

requireRoutes.keys().forEach((route) => {
  routes = routes.concat(requireRoutes(route).default);
});

export default routes;
